export enum OperatingProcedures {
  RulesOne = 'Порядок 1',
  RulesTwo = 'Порядок 2',
  RulesThree = 'Порядок 3',
}
